import './index.scss';

import React, { Component } from 'react';

import { getMobileHeight, getDesktopHeight } from '../../utils/services';

let initialX = null;
let initialY = null;

class Carousel extends Component {
  constructor(props) {
    super(props);
    this.ref = React.createRef();
    this.state = {
      activeIndex: 0
    };
    // const { innerWidth } = window;
    this.height = this.heightCalc();
  }

  componentDidMount() {
    const { setInterval } = this;
    setInterval();
    const myElement =
      document && document.getElementsByClassName('carousel')[0];
    if (myElement && window.innerWidth < 768) {
      myElement.addEventListener('touchstart', this.handleTouchStart, false);
      myElement.addEventListener('touchmove', this.handleTouchMove, false);
    }
  }

  componentDidUpdate(prevProps) {
    const { stopCarouselSlideShow } = this.props;
    if (stopCarouselSlideShow !== prevProps.stopCarouselSlideShow) {
      const { setInterval, clearInterval } = this;
      if (stopCarouselSlideShow) clearInterval();
      else setInterval();
    }
  }

  componentWillUnmount() {
    const { clearInterval } = this;
    clearInterval();
    const myElement =
      document && document.getElementsByClassName('carousel')[0];
    if (myElement && window.innerWidth < 768) {
      myElement.removeEventListener('touchstart', this.handleTouchStart, false);
      myElement.removeEventListener('touchmove', this.handleTouchMove, false);
    }
  }

  setInterval = () => {
    const self = this;
    this.interval = setInterval(() => self.setIndex(), 4000);
  };

  setIndex = () => {
    let { activeIndex } = this.state;
    const { carouselData } = this.props;
    if (activeIndex !== carouselData.length - 1) {
      activeIndex += 1;
    } else {
      activeIndex = 0;
    }
    this.setState({ activeIndex });
  };

  swipeSetIndex = isAdd => {
    let { activeIndex } = this.state;
    const { carouselData } = this.props;
    const carouselLength = carouselData.length - 1;

    if (isAdd) {
      if (activeIndex === carouselLength) activeIndex = 0;
      else activeIndex += 1;
    } else if (!isAdd) {
      if (activeIndex === 0) activeIndex = carouselLength;
      else activeIndex -= 1;
    }

    this.setState({ activeIndex });
    this.setInterval();
  };

  setIndicatorIndex = index => {
    this.clearInterval();
    this.setState({ activeIndex: index });
    this.setInterval();
  };

  clearInterval = () => {
    const self = this;
    clearInterval(self.interval);
  };

  handleTouchStart = e => {
    initialX = e.touches[0].clientX;
    initialY = e.touches[0].clientY;
  };

  handleTouchMove = e => {
    if (initialX === null) return;
    if (initialY === null) return;

    const currentX = e.touches[0].clientX;
    const currentY = e.touches[0].clientY;

    const diffX = initialX - currentX;
    const diffY = initialY - currentY;

    if (Math.abs(diffX) > Math.abs(diffY)) {
      const { swipeSetIndex } = this;
      this.clearInterval();
      if (diffX > 0) {
        // swiped left
        swipeSetIndex(true);
      } else {
        swipeSetIndex(false); // swiped right
      }
    }

    initialX = null;
    initialY = null;
    e.preventDefault();
  };

  heightCalc = () => {
    const { innerWidth } = window;
    const { isFromFreshTaste } = this.props;
    if (innerWidth > 1023 && !isFromFreshTaste) {
      return getDesktopHeight(300);
    }
    if (innerWidth > 1023 && isFromFreshTaste) {
      return getDesktopHeight(600);
    }

    return getMobileHeight(200);
  };

  render() {
    const { activeIndex } = this.state;
    const { carouselData, onClick } = this.props;
    const { height } = this;
    return (
      <div
        className={`carousel ${
          !(carouselData && carouselData.length) ? 'carousel_nodata' : ''
        }`}
        style={{ height }}
        key={0}
      >
        <div className="carousel__content" key={0}>
          {carouselData.map((data, index) => {
            const { mobile_1x, web_1x } = data;
            let img = mobile_1x;
            if (data.mobile_2x) {
              img = data.mobile_2x;
            }
            return (
              <React.Fragment key={index}>
                <div
                  role="presentation"
                  onClick={() => onClick(data, index)}
                  key={index}
                  className={
                    activeIndex === index
                      ? 'carousel__item active'
                      : 'carousel__item'
                  }
                >
                  <img
                    src={window.innerWidth > 1023 ? web_1x : img}
                    alt={`img ${img}`}
                    className="carousel__image"
                  />
                </div>
              </React.Fragment>
            );
          })}
        </div>
        {carouselData && carouselData.length > 1 ? (
          <div className="carousel__indicator">
            {carouselData.map((data, index) => {
              return (
                <span
                  role="presentation"
                  onClick={() => this.setIndicatorIndex(index)}
                  className={`u_cursor_pointer carousel__indicator-item ${
                    activeIndex === index ? 'active' : ''
                  }`}
                  key={index}
                />
              );
            })}
          </div>
        ) : (
          ''
        )}
      </div>
    );
  }
}

export default Carousel;
